import { IRow } from '../../CostOfSalesForm/utils/form';
import { EXPENSE_COLUMN_NAMES } from '../../utils/form';

export const getTotalItemsWeightedAverage = (items: IRow[], fixedValue = true) => {
  const filteredData = items.filter((item) => Number(item[EXPENSE_COLUMN_NAMES.COLUMN_0]) > 0);
  if (!filteredData.length) return ''

  const totalWeight = filteredData.reduce((sum, item) => sum + Number(item[EXPENSE_COLUMN_NAMES.COLUMN_0]), 0);

  const weightedSum = filteredData.reduce((sum, item) => {
    return sum + Number(item[EXPENSE_COLUMN_NAMES.COLUMN_1]) * Number(item[EXPENSE_COLUMN_NAMES.COLUMN_0]);
  }, 0);

  const weightedAverage = weightedSum / totalWeight;

  return fixedValue ? weightedAverage.toFixed(2) : String(weightedAverage);
};
